// src/Api/useSetCategoryApi.js
import { useState } from "react";
import { post } from "./api";

const useSetCategoryApi = () => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");

  const setCategory = async (payload) => {
    try {
      setError(""); // reset error
      setResult(null); // reset result

      // 🔍 Basic URL validation
      const urlPattern = /^(https?:\/\/)?([^\s/$.?#].[^\s]*)$/i;
      if (!payload.url || !urlPattern.test(payload.url)) {
        setError("Please enter a valid URL");
        throw new Error("Invalid URL");
      }

      // Category validation
      if (!payload.categories || payload.categories.length === 0) {
        setError("Please select at least one category");
        throw new Error("No categories selected");
      }

      setLoading(true);

      console.log("Sending to API:", payload); // Debug log

      // 🔥 API call
      const response = await post("add", payload);

      console.log("Set Category Response:", response);

      setResult({
        success: response.success !== false,
        message: response.message || "Category applied successfully",
        data: response.data || null,
      });

      return response;
    } catch (error) {
      console.error("Set Category Error:", error);

      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Failed to apply category";

      setError(errorMessage);
      setResult({
        success: false,
        message: errorMessage,
      });

      throw error; // Re-throw to handle in component
    } finally {
      setLoading(false);
    }
  };

  return { setCategory, result, loading, error, setError };
};

export default useSetCategoryApi;
